<style scoped="" type="text/css"></style>
<template>
  <div style="" v-loading="loading">
    <div v-show="!readOnly">
      <el-upload ref="upload" :action="domain" :show-file-list="false" :headers="headers" :name="'files'" :before-upload="beforeUpload" :on-success="handleOnSuccess" :on-progress="handleOnProgress" :on-error="handleOnError" :multiple="true" :accept="accept">
        <div style="display: flex;align-items: center;">
          <el-button size="mini" icon="yicon yicon-files_upload" plain>
            {{ $t(btName) }}
          </el-button>
          <div>
            <slot name="limitMsg">
              <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                {{ $t('zuiduoshangchuan') }}
              </span>
              <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                <span>{{ limit }}</span>
                <span style="color: #909399;font-size: 14px;font-weight: normal;">
                  {{ $t('zhichitupian') }}
                </span>
              </span>
            </slot>
          </div>
        </div>
      </el-upload>
    </div>
    <div v-show="isShowFiles" style="display: flex;border-radius: 4px;flex-flow: wrap;margin-top: 8px;">
      <div v-for="(file, index) in fileList" style="cursor: pointer;display: flex;padding: 2px 8px;background: #F4F4F5;align-items: center;margin-left: 8px;flex-shrink: 0;margin-bottom: 8px; ">
        <i style="color: #C0C4CC;" class="yicon yicon-attachment"></i>
        <span @click="openFile(file)" style="color: #909399;margin-left: 8px;">{{ file.name }}</span>
        <i v-show="!readOnly" @click="remove(index)" style="color: #C0C4CC;margin-left: 8px;margin-right: 6px;" class="yicon yicon-close2"></i>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'yi_upload',
  //props: ['accept', 'multiple', 'max', 'files', 'read_only', 'width', 'height'],
  components: {},
  props: {
    accept: {
      type: String,
      default: 'image/png, image/jpeg,image/gif,application/pdf,application/zip,application/msword,application/vnd.ms-excel'
    },
    max: {
      type: Number,
      default: 999
    },
    limit: {
      type: Number,
      default: 1
    },
    ids: {},
    readOnly: {
      type: Boolean,
      default: false
    },
    isShowFiles: {
      type: Boolean,
      default: true
    },
    btName: {
      type: String,
      default: 'shangchuanwenjian'
    }
  },

  data() {
    return {
      domain: process.env.NODE_ENV == 'development' ? global.URL_DEV_API_BASE_DOMAIN + '/web/customer/files/upload?publicly=false' : process.env.VUE_APP_SERVER == 'preview' ? global.URL_PRE_API_BASE_DOMAIN + '/web/customer/files/upload?publicly=false' : global.URL_PROD_API_BASE_DOMAIN + '/web/customer/files/upload?publicly=false',
      headers: {
        Authorization: localStorage.getItem('token')
      },
      fileList: [],
      fileListTmp: [],
      loading: false
    };
  },
  created() {
    this.getFileByIds();
  },
  mounted() { },
  computed: {},
  watch: {
    ids: function (newValue, oldValue) {
      //this.getFileByIds()
    }
  },
  methods: {
    async getFileByIds() {
      if (this.ids == null || this.ids == '' || this.ids == []) {
        return;
      }

      let response = await this.http.get('/web/customer/files/getFileByIds', {
        params: {
          ids: this.ids
        }
      });
      this.fileList = response.data;
      this.fileListTmp = this.utils.copy(this.fileList);
      this.updateIds();
    },

    beforeUpload(file) {
      if (this.fileList.length >= this.limit) {
        this.utils.errorMessage(this.$t('shuliangyidazuidashangxian'));
        return false;
      }
      // if (file.size / 1024 / 1024 > 10) {
      //   this.utils.errorMessage(this.$t('wenjiandaxiaobunengchaoguo10MB'));
      //   return false;
      // }
      return true;
    },
    // 上传时
    handleOnProgress(event, file, fileList) {
      this.loading = true;
    },
    // 上传成功
    handleOnSuccess(response, file, fileList) {
      if (response.code !== 200) {
        this.loading = false;
        this.$message.error(response.msg);
        return;
      }
      if (this.fileList.length < this.limit) {
        this.fileList.push(response.data[0]);
      }
      this.loading = false;
      this.updateIds();
      this.$emit('afterUpload');
    },
    // 上传失败
    handleOnError(error, file, fileList) {
      this.loading = false;
    },

    remove(index) {
      this.fileListTmp.splice(index, 1);
      this.fileList.splice(index, 1);
      this.updateIds();
      this.$emit('afterRemove');
    },
    updateIds() {
      if (this.limit > 1) {
        let ids = this.fileList.map(item => {
          return item.id;
        });
        console.log(ids);
        this.$emit('update:ids', ids);
      } else {
        if (this.fileList.length > 0) {
          this.$emit('update:ids', this.fileList[0].id);
        } else {
          this.$emit('update:ids', null);
        }
      }
    },
    openFile(file) {
      let baseURL = process.env.NODE_ENV == 'development' ? global.URL_DEV_API_BASE_DOMAIN : process.env.VUE_APP_SERVER == 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN;
      window.open(baseURL + '/web/customer/files/viewFileByFileId/' + file.key);
    }
  }
};
</script>
